$(document).ready(function () {
    unbindFormulaireAdresse();
    bindFormulaireAdresse($('#adresse-principale-form-wrapper'));
    bindFormulaireAdresse($('#adresse-invite-form-wrapper'));

    // CHOIX PAYS
    $(document).on("change", '#CodePays', function (e) {

        var url = "";
        var dataForm = null;
        var currentForm = $(this).closest("form");

        // Formulaire utilisé dans le carnet d'adresses
        if ($('#form-adresse').html() != null && $('#form-adresse').html().length > 0) {
            dataForm = currentForm.serialize();
            url = "/EspaceClient/GetFormulaireAdresse?";
        }
            // Sinon formulaire utilisé dans le panier
        else if ($('#form-modification-adresse').html() != null && $('#form-modification-adresse').html().length > 0) {
            url = "/CartAction/GetFormulaireAdresse?";
            dataForm = currentForm.serialize();
        }


        $.ajax({
            url: url + dataForm,
            data: {
            },
            success: function (result) {
                if (result != null && typeof (result) != "undefined" && result.length > 0) {
                    var $form = $('#autre-adresse-form-wrapper');
                    // DIV utilisée pour écrire le résultat de la vue dans le carnet d'adresses du panier
                    if ($('#autre-adresse-form-wrapper').html() != null && $('#autre-adresse-form-wrapper').html().length > 0) {
                        $('#autre-adresse-form-wrapper').html(result);
                        $form = $('#autre-adresse-form-wrapper');
                    }
                    // DIV utilisée pour écrire le résultat de la vue pour l'adresse principale 
                    //else if (currentForm.closest('#adresse-form').html() != null && currentForm.closest('#adresse-form').html().length > 0) {
                    else if ($('#adresse-principale-form-wrapper').html() != null && $('#adresse-principale-form-wrapper').html().length > 0) {
                        $('#adresse-principale-form-wrapper').html(result);
                        $form = $('#adresse-principale-form-wrapper');
                    }
                    else if ($('#adresse-form-wrapper').html() != null && $('#adresse-form-wrapper').html().length > 0) {
                        $('#adresse-form-wrapper').html(result);    // Formulaires dans l'espace Client
                        $form = $('#adresse-form-wrapper');
                    }

                    // On met le focus sur le CP ou le CP ville suivant le formulaire adresse
                    currentForm.find('#CodePostalVille').focus();
                    currentForm.find('#CodePostal').focus();

                    unbindFormulaireAdresse();
                    bindFormulaireAdresse($form);
                }

                Foundation.libs.common.hidePreloader();
            },
            beforeSend: function () {
                //$('#preloader').show();
                Foundation.libs.common.showPreloader();
            }
        });
    });


});

function bindFormulaireAdresse($form) {

    if (typeof ($form) != 'undefined') {
        if ($('#IsPaysGereParWSLaPoste').val() == 'True') {
            bindLaPoste($form);
        }
        else if ($('#IsPaysGereParCapAdresse').val() == 'True') {
            bindCapAdress();
        }

        var toggleTel = $(".toggle-telephone input[type=radio]");
        if (typeof (toggleTel) != "undefined")
        {
            toggleTel.off("change").on("change", function (e) {
                if (e.target.value == "True") {
                    $(".telephone-wrapper").show();
                }
                else {
                    $(".telephone-wrapper").hide();
                }
            })
        }
    }
}

function unbindFormulaireAdresse() {
    $(document).off('keypress', '#Voie');
    $(document).off('focus', '#CodePostalVille');
    //$(document).off('focus', '#CodePostalVille, #Voie');
    $(document).off('blur', '#CodePostalVille, #Voie, #Numero');

    if (jQuery('#CodePostalVille').data('autocomplete')) {
        jQuery('#CodePostalVille').autocomplete("destroy");
        jQuery('#CodePostalVille').removeData('autocomplete');
    }

    if (jQuery('#Voie').data('autocomplete')) {
        jQuery('#Voie').autocomplete("destroy");
        jQuery('#Voie').removeData('autocomplete');
    }
}

function bindCapAdress() {

    $(document).on("keypress", '#Voie', function (event) {
        var keycode = (event.keyCode ? event.keyCode : event.which);
        if (keycode == '13') {
            event.preventDefault();

        }
    });

    // FOCUS SUR CODE POSTAL/LOCALITE
    $(document).on("focus", '#CodePostalVille', function (e) {
        // Si on trouve un code alpha3 de pays, c'est qu'on le gère via cap adresse
        if ($(':visible #CodePaysAlpha3').val() != null && $('#CodePaysAlpha3').val().length > 0) {
            if (!$(this).data("autocomplete")) {
                $(this).autocomplete({
                    source: function (request, response) {
                        $.getJSON("/Espaceclient/SearchVilles?codepays=" + $('#CodePaysAlpha3').val() + "&term=" + $("#CodePostalVille").val(), function (data) {
                            response($.map(data.Data, function (item) {
                                return {
                                    label: item.NameFormatted,
                                    value: item.LocalityId,

                                    codePostal: item.PostalCode,
                                    localityId: item.LocalityID,
                                    localityName: item.Name,
                                    localityHasStreets: item.HasStreets,
                                    localitySynonym: item.Synonym,
                                    additionalLocalityInfo1: item.AdditionalInfo1,
                                    additionalLocalityInfo2: item.AdditionalInfo2,
                                    additionalLocalityInfo3: item.AdditionalInfo3,
                                    additionalLocalityInfo4: item.AdditionalInfo4,
                                    additionalLocalityInfo5: item.AdditionalInfo5
                                };
                            }));
                        });
                    },
                    minLength: 1,
                    autoFocus: true,
                    appendTo: '#CodePostalVille-autocomplete',
                    search: function (event, ui) {
                        $("input[name=Voie]:visible").prop('disabled', true);
                        $("input[name=Numero]:visible").prop('disabled', true);
                        $("input[name=CompletmentLocalite1]:visible").prop('disabled', true);
                        $("input[name=CompletmentLocalite2]:visible").prop('disabled', true);
                        $("input[name=ComplementVoie1]:visible").prop('disabled', true);
                        $("input[name=ComplementVoie2]:visible").prop('disabled', true);
                        $("input[name=LocaliteId]").val('');
                        $("input[name=CodePostal]").val('');
                        $("input[name=Localite]").val('');
                        $("input[name=CompletmentLocalite1]").val('');
                        $("input[name=CompletmentLocalite2]").val('');
                        $("input[name=CompletmentLocalite3]").val('');
                        $("input[name=CompletmentLocalite4]").val('');
                        $("input[name=CompletmentLocalite5]").val('');
                        $('input[name=Voie]:visible').val('');
                        $('input[name=VoieId]').val('');
                        $('input[name=TypeVoie]').val('');
                        $('input[name=TypeVoieAbrege]').val('');
                        $('input[name=VoieSynonym]').val('');
                        $("input[name=ComplementVoie1]").val('');
                        $("input[name=ComplementVoie2]").val('');
                        $("input[name=ComplementVoie3]").val('');
                        $("input[name=ComplementVoie4]").val('');
                        $("input[name=ComplementVoie5]").val('');
                        $("input[name=Numero]:visible").val('');
                        $('input[name=Numero]:visible').removeClass("input-validation-error");
                        $('input[name=Numero]:visible').next('.field-validation-error').removeClass('field-validation-error').addClass('field-validation-valid');
                        $("input[name=NumeroExtension]:visible").val('');
                    },
                    select: function (event, ui) {
                        event.preventDefault();

                        $('input[name=CodePostalVille]:visible').val($.trim(ui.item.codePostal + " " + ui.item.localityName));
                        $("input[name=LocaliteId]").val(ui.item.localityId);
                        $("input[name=CodePostal]").val(ui.item.codePostal);
                        $("input[name=Localite]").val(ui.item.localityName);
                        $("input[name=CompletmentLocalite1]").val(ui.item.additionalLocalityInfo1);
                        $("input[name=CompletmentLocalite2]").val(ui.item.additionalLocalityInfo2);
                        $("input[name=CompletmentLocalite3]").val(ui.item.additionalLocalityInfo3);
                        $("input[name=CompletmentLocalite4]").val(ui.item.additionalLocalityInfo4);
                        $("input[name=CompletmentLocalite5]").val(ui.item.additionalLocalityInfo5);
                        $("input[name=Voie]:visible").prop('disabled', false);
                        $("input[name=Voie]:visible").focus();
                        $("input[name=Voie]:visible").select();
                        $("input[name=CompletmentLocalite1]").prop('disabled', false);
                        $("input[name=CompletmentLocalite2]").prop('disabled', false);
                    }
                });
            }
        }
    });

    // QUITTE LA ZONE CODEPOSTAL VILLE
    $(document).on("blur", '#CodePostalVille', function (event) {
        // Si on quitte la zone de saisie du cp - ville sans avoir choisi une proposition dans la liste (où s'il n'y en a pas)
        // l'adresse sera recontrôlée avant enregistrement
        // On réactive la voie
        // La saisie du cp - ville étant obligatoire on vérifie avant de réactiver
        if ($(":visible #CodePostalVille").val() != null && $(":visible #CodePostalVille").val().length > 0) {
            //$("#Voie").prop('disabled', false);

            //$("#Voie").caretToEnd();


            // On rappel Cap adresse pour revalider la saisie
            //$.getJSON("/Espaceclient/SearchVilles?codepays=" + $('#CodePaysAlpha3').val() + "&term=" + $("#CodePostalVille").val(), function (data) {
            //    if (data) {

            //    }
            //});
        }
    });

    $(document).on("focus", '#Voie', function (e) {
        // Si on trouve un code alpha3 de pays, c'est qu'on le gère via cap adresse
        if ($(':visible #CodePaysAlpha3').val() != null && $('#CodePaysAlpha3').val().length > 0) {
            if (!$(this).data("autocomplete")) {
                $(this).autocomplete({
                    source: function (request, response) {
                        $.getJSON("/Espaceclient/SearchVoies?codepays=" + $('#CodePaysAlpha3').val() + "&idLocalite=" + $("#LocaliteId").val() + "&codePostal=" + $("#CodePostal").val() + "&term=" + $("#Voie").val(), function (data) {
                            response($.map(data.Data, function (item) {
                                return {
                                    label: item.NameFormatted,
                                    value: item.streetId,

                                    codePostal: item.PostalCode,
                                    localityId: item.LocalityID,
                                    localityName: item.LocalityName,
                                    streetId: item.StreetID,
                                    streetName: item.Name,
                                    streetType: item.Type,
                                    abbreviatedStreetType: item.AbbreviatedType,
                                    streetSynonym: item.Synonym,
                                    additionalStreetInfo1: item.AdditionalInfo1,
                                    additionalStreetInfo2: item.AdditionalInfo2,
                                    additionalStreetInfo3: item.AdditionalInfo3,
                                    additionalStreetInfo4: item.AdditionalInfo4,
                                    additionalStreetInfo5: item.AdditionalInfo5,
                                    streetNumber: item.Number,
                                    streetNumberExt: item.NumberExt,
                                    streetHasNumbers: item.HasNumbers
                                };
                            }));
                        });
                    },
                    minLength: 0,
                    autoFocus: true,
                    appendTo: '#Voie-autocomplete',
                    search: function (event, ui) {
                        $(":visible #ComplementVoie1").prop('disabled', true);

                        $('input[name=VoieId]').val('');
                        $('input[name=TypeVoie]').val('');
                        $('input[name=TypeVoieAbrege]').val('');
                        $('input[name=VoieSynonym]').val('');
                        $("input[name=Numero]:visible").val('');
                        $("input[name=NumeroExtension]").val('');
                        $("input[name=ComplementVoie1]").val('');
                        $("input[name=ComplementVoie2]").val('');
                        $("input[name=ComplementVoie3]").val('');
                        $("input[name=ComplementVoie4]").val('');
                        $("input[name=ComplementVoie5]").val('');
                    },
                    select: function (event, ui) {
                        event.preventDefault();

                        $("input[name=LocaliteId]").val(ui.item.localityId);
                        $("input[name=CodePostal]").val(ui.item.codePostal);
                        $("input[name=Localite]").val(ui.item.localityName);
                        $('input[name=CodePostalVille]:visible').val(ui.item.codePostal + " " + ui.item.localityName);
                        $('input[name=Voie]:visible').val(ui.item.streetName);
                        $('input[name=VoieId]').val(ui.item.streetId);
                        $('input[name=TypeVoie]').val(ui.item.streetType);
                        $('input[name=TypeVoieAbrege]').val(ui.item.abbreviatedStreetType);
                        $('input[name=VoieSynonym]').val(ui.item.streetSynonym);
                        $("input[name=ComplementVoie1]").val(ui.item.additionalStreetInfo1);
                        $("input[name=ComplementVoie2]").val(ui.item.additionalStreetInfo2);
                        $("input[name=ComplementVoie3]").val(ui.item.additionalStreetInfo3);
                        $("input[name=ComplementVoie4]").val(ui.item.additionalStreetInfo4);
                        $("input[name=ComplementVoie5]").val(ui.item.additionalStreetInfo5);
                        $("input[name=Numero]:visible").val(ui.item.streetNumber);
                        $("input[name=NumeroExtension]").val(ui.item.streetNumberExt);
                        $("input[name=Numero]:visible").prop('disabled', false);
                        $("input[name=Numero]:visible").focus();
                        $('input[name=Numero]:visible').removeClass("input-validation-error");
                        $('input[name=Numero]:visible').next('.field-validation-error').removeClass('field-validation-error').addClass('field-validation-valid');
                        $("input[name=ComplementVoie1]").prop('disabled', false);
                    }
                });

                $(this).autocomplete("search", $(this).val());
            }
        }
    });

    // QUITTE LA ZONE VOIE
    $(document).on("blur", '#Voie', function (e) {
        // Si on quitte le champ Voie sans avoir choisi une proposition cap adresse (où s'il n'y en a pas)
        if ($(":visible #Voie").val() != null && $(":visible #Voie").val().length > 0) {
            $(":visible #Numero").prop('disabled', false);
            //$("#Numero").focus();
            //$("#Numero").caretToEnd();
        }
        else if ($("#VoieId").val() != null && $("#VoieId").val().length > 0) {
            if ($(':visible #CodePaysAlpha3').val() != null && $(':visible #CodePaysAlpha3').val().length > 0) {
                $.getJSON("/Espaceclient/CheckNumerosVoie?codepays=" + $(':visible #CodePaysAlpha3').val() + "&idLocalite=" + $(":visible #LocaliteId").val() + "&codePostal=" + $(":visible #CodePostal").val() + "&idVoie=" + $(":visible #VoieId").val() + "&term=" + $(":visible #Numero").val(), function (data) {
                    if (data != null && data.Data != null) {
                        $("input[name=LocaliteId]:visible").val(data.Data.LocalityID);
                        $("input[name=CodePostal]:visible").val(data.Data.PostalCode);
                        $("input[name=Localite]:visible").val(data.Data.LocalityName);
                        $('input[name=CodePostalVille]:visible').val(data.Data.PostalCode + " " + data.Data.LocalityName);
                        $("input[name=VoieId]:visible").val(data.Data.StreetID);
                        $("input[name=NumeroExtension]:visible").val(data.Data.NumberExt);
                        $('input[name=Numero]:visible').removeClass("input-validation-error");
                        $('input[name=Numero]:visible').next('.field-validation-error').removeClass('field-validation-error')
                            .addClass('field-validation-valid')
                    }
                    else {
                        $(':visible #Numero').addClass("input-validation-error");
                        $(':visible #Numero').next('.field-validation-valid').removeClass('field-validation-valid')
                                .addClass('field-validation-error')
                                .text(data.Erreur);
                    }
                });
            }
        }
    });

    // QUITTE LA ZONE NUMERO DE VOIE
    $(document).on("blur", '#Numero', function (e) {
        // Si on trouve un code alpha3 de pays, c'est qu'on le gère via cap adresse
        if ($(':visible #CodePaysAlpha3').val() != null && $('#CodePaysAlpha3').val().length > 0) {
            $.getJSON("/Espaceclient/CheckNumerosVoie?codepays=" + $('#CodePaysAlpha3').val() + "&idLocalite=" + $(":visible #LocaliteId").val() + "&codePostal=" + $(":visible #CodePostal").val() + "&idVoie=" + $(":visible #VoieId").val() + "&term=" + $(":visible #Numero").val(), function (data) {
                if (data.IsValid) {
                    $("input[name=LocaliteId]:visible").val(data.Data.LocalityID);
                    $("input[name=CodePostal]:visible").val(data.Data.PostalCode);
                    $("input[name=Localite]:visible").val(data.Data.LocalityName);
                    $('input[name=CodePostalVille]:visible').val(data.Data.PostalCode + " " + data.Data.LocalityName);
                    $("input[name=VoieId]:visible").val(data.Data.StreetID);
                    $("input[name=NumeroExtension]:visible").val(data.Data.NumberExt);
                    $('input[name=Numero]:visible').removeClass("input-validation-error");
                    $('input[name=Numero]:visible').next('.field-validation-error').removeClass('field-validation-error')
                        .addClass('field-validation-valid')
                }
                else {
                    $('input[name=Numero]:visible').addClass("input-validation-error");
                    $('input[name=Numero]:visible').next('.field-validation-valid').removeClass('field-validation-valid')
                        .addClass('field-validation-error')
                        .text(data.Erreur);
                }
            });
        }
    });

}

function bindLaPoste($form) {
    window.server = '/adresse/call/'; //'jsonp';
    //window.license = 'hmmmm';
    window.last_log_line = '';

    var options;

    options = {
        server: window.server,
        license: window.license,
        country: '#CodePaysAlpha3',
        zip: '#CodePostal',
        city: '#Localite',
        city_id: '#LocaliteId',
        street: '#Voie',
        street_id: '#VoieId',
        number: '#Numero',
        compl: '#ComplementAdresse1',
        local: '#LieuDit',
        prov: '#LieuDit',
        company: '#id_company1',
        geoloc: "",
        realtime_override: 1,
        city_search: 0
    };
    window.dqeObject = $form.dqe(options);

}

function bindLaPosteDemandeClient() {
    window.server = '/adresse/call/'; //'jsonp';
    //window.license = 'hmmmm';
    window.last_log_line = '';
    var options;

    options = {
        server: window.server,
        license: window.license,
        country: '#AdresseExpedition_CodePaysAlpha3',
        zip: '#AdresseExpedition_CodePostal',
        city: '#AdresseExpedition_Localite',
        city_id: '#AdresseExpedition_LocaliteId',
        street: '#AdresseExpedition_Voie',
        street_id: '#AdresseExpedition_VoieId',
        number: '#AdresseExpedition_Numero',
        compl: '#AdresseExpedition_ComplementAdresse1',
        local: '#AdresseExpedition_LieuDit',
        prov: '#AdresseExpedition_LieuDit',
        company: '#AdresseExpedition_id_company1',
        geoloc: "",
        realtime_override: 1,
        city_search: 0
    };
    window.dqeObject = $("#demande-catalog-non-client-form").dqe(options);

}

function bindLaPosteDemandeSociete() {
    window.server = '/adresse/call/'; //'jsonp';
    //window.license = 'hmmmm';
    window.last_log_line = '';
    var options;

    options = {
        server: window.server,
        license: window.license,
        country: '#AdresseSociete_CodePaysAlpha3',
        zip: '#AdresseSociete_CodePostal',
        city: '#AdresseSociete_Localite',
        city_id: '#AdresseSociete_LocaliteId',
        street: '#AdresseSociete_Voie',
        street_id: '#AdresseSociete_VoieId',
        number: '#AdresseSociete_Numero',
        compl: '#AdresseSociete_ComplementAdresse1',
        local: '#AdresseSociete_LieuDit',
        prov: '#AdresseSociete_LieuDit',
        company: '#AdresseSociete_id_company1',
        geoloc: "",
        realtime_override: 1,
        city_search: 0
    };
    window.dqeObject = $("#demande-non-client-form").dqe(options);

}
function bindLaPosteDemandeSpecifique(attrName) {
    window.server = '/adresse/call/'; //'jsonp';
    //window.license = 'hmmmm';
    window.last_log_line = '';
    var options;

    options = {
        server: window.server,
        license: window.license,
        country: '#' + attrName  + '_CodePaysAlpha3',
        zip: '#' + attrName  + '_CodePostal',
        city: '#' + attrName  + '_Localite',
        city_id: '#' + attrName  + '_LocaliteId',
        street: '#' + attrName  + '_Voie',
        street_id: '#' + attrName  + '_VoieId',
        number: '#' + attrName  + '_Numero',
        compl: '#' + attrName  + '_ComplementAdresse1',
        local: '#' + attrName  + '_LieuDit',
        prov: '#' + attrName  + '_LieuDit',
        company: '#' + attrName  + '_id_company1',
        geoloc: "",
        realtime_override: 1,
        city_search: 0
    };
    window.dqeObject = $("#demande-non-client-form").dqe(options);

}
function bindFormulaireCodePostalVilleBij()
{
    window.server = '/adresse/call/'; //'jsonp';
    //window.license = 'hmmmm';
    window.last_log_line = '';
    options = {
        server: window.server,
        license: window.license,
        //country: '#id_country1',
        zipcity: 'input[name=CodePostal]',
        city_id: 'input[name=CodeInsee]'
    };
    window.dqeObject = $('#frmRechercheBijouterie').dqe(options);
}
function bindFormulaireCodePostalVillePointRetrait() {
    window.server = '/adresse/call/'; //'jsonp';
    //window.license = 'hmmmm';
    window.last_log_line = '';
    options = {
        server: window.server,
        license: window.license,
        //country: '#id_country1',
        zipcity: 'input[name=CodePostal]',
        city_id: 'input[name=CodeInsee]'
    };
    window.dqeObject = $('#frmRecherchePointRetrait').dqe(options);
}

// Recherche bijouterie clic'n'collect.
function bindFormulaireCodePostalVilleClicknCollect() {
    window.server = '/adresse/call/'; //'jsonp';
    //window.license = 'hmmmm';
    window.last_log_line = '';
    options = {
        server: window.server,
        license: window.license,
        //country: '#id_country1',
        zipcity: 'input[name=CodePostal]',
        city_id: 'input[name=CodeInsee]'
    };
    window.dqeObject = $('#frmRechercheClicknCollect').dqe(options);
}